import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "../../../config/api.config";
import { Employee, EmployeeRequest } from "../employee.model";

@Injectable({
  providedIn: "root",
})
export class EmployeeService {
  constructor(private http: HttpClient) {}

  findAll(): Observable<Employee[]> {
    return this.http.get<Employee[]>(`${Config.webApiUrl}/v1/person`);
  }

  findAllByContractType(contractType: string): Observable<any[]> {
    const params = new HttpParams().set("contractType", contractType);
    return this.http.get<any[]>(`${Config.webApiUrl}/v1/person/contract-type`, { params });
  }

  findAllEmployees(): Observable<any[]> {
    return this.http.get<any[]>(`${Config.webApiUrl}/v1/person/contract-type`);
  }

  create(employee: EmployeeRequest, file: File | null): Observable<any> {
    const formData = new FormData();
    formData.append("data", new Blob([JSON.stringify(employee)], { type: "application/json" }));
    formData.append("file", file);
    return this.http.post(`${Config.webApiUrl}/v1/person`, formData);
  }

  update(id: string, employee: EmployeeRequest, file?: File): Observable<void> {
    const formData = new FormData();
    formData.append("data", new Blob([JSON.stringify(employee)], { type: "application/json" }));

    if (file) {
      formData.append("file", file);
    }

    return this.http.put<void>(`${Config.webApiUrl}/v1/person/${id}`, formData);
  }

  delete(id: string): Observable<Employee> {
    return this.http.delete<Employee>(`${Config.webApiUrl}/v1/person/${id}`);
  }
}
